import React, { useState, useEffect, useRef } from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { Search as SearchIcon, Clear as ClearIcon } from "@material-ui/icons";

export default function GlobalSearch({
  value = "",
  onSearchChange,
  placeholder = "Search...",
  debounce = 400,
  fullWidth = false,
  disabled = false,
  className = "",
  style = {},
}) {
  const [localValue, setLocalValue] = useState(value);

  // Keep local value in sync with prop value when prop changes
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const timerRef = useRef(null);

  const handleChange = (e) => {
    const val = e.target.value;
    setLocalValue(val);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      onSearchChange(val);
    }, debounce);
  };

  const handleClear = () => {
    setLocalValue("");
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    onSearchChange("");
  };

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <TextField
      className={className}
      style={{
        minWidth: 200,
        backgroundColor: "#fff",
        borderRadius: "4px",
        ...style,
      }}
      size="small"
      variant="outlined"
      fullWidth={fullWidth}
      disabled={disabled}
      placeholder={placeholder}
      value={localValue}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: localValue ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={handleClear}
              disabled={disabled}
              edge="end"
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
        style: { fontSize: "0.875rem" }
      }}
    />
  );
}
